import controller from './query-rule-variable.controller';
import template from './query-rule-variable.html';
import './query-rule-variable.scss';

export default {
	controller,
	template,
	bindings: {
		bEditor:    '<?queryEditor',
		required:   '<?ngRequired',
		rule:       '<ngModel',
	},
	require:  {
		ngModelCtrl: '?ngModel',
		builder:     '^^?queryBuilder',
		editor:      '^^?queryEditor',
	},
};
